import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { pageContext } from 'ctm-util-functions';
import { useBrandContentFactory } from 'ctm-app/client/hooks/useBrandContentFactory';
import { Anchor } from '../anchor/anchor';
import { Icon } from '../icon/icon';
import { Text } from '../text/text';

import styles from './cross_sell.css';

/**
 * @todo FUTURE: This should come from a database of available verticals.
 * Some white labels have different verticals enabled for them.
 * @type {Object} An array of verticals by brand code
 */
const verticalLists = {
    ctm: [
        { key: 'health', label: 'Health', icon: 'vert_health', href: '/health-insurance/' },
        { key: 'car-insurance', label: 'Car', icon: 'car_solid', href: '/car-insurance/' },
        { key: 'life-insurance', label: 'Life', icon: 'vert_life', href: '/life-insurance/' },
        { key: 'home-contents-insurance', label: 'Home', icon: 'vert_home', href: '/home-contents-insurance/' },
        { key: 'travel-insurance', label: 'Travel', icon: 'vert_travel', href: '/travel-insurance/' },
        { key: 'income-protection', label: 'Income <br />Protection', icon: 'vert_ip', href: '/income-protection/' },
        { key: 'roadside-assistance', label: 'Roadside', icon: 'vert_roadside', href: '/roadside-assistance/' },
        { key: 'fuel', label: 'Fuel', icon: 'vert_fuel', href: '/fuel/' },
        { key: 'pet-insurance', label: 'Pet', icon: 'vert_pet', href: '/pet-insurance/' },
        { key: 'business-insurance', label: 'Business', icon: 'vert_business', href: '/business-insurance/' },
        {
            key: 'landlord',
            label: 'Landlord',
            icon: 'vert_landlords',
            href: '/home-contents-insurance/landlords-insurance/'
        },
        { key: 'money', label: 'Money', icon: 'vert_money', href: '/credit-cards/' }
    ]
};

/**
 * Renders an icon on the related products/cross sell style view.
 * @param {Object} props React props
 * @returns {CrossSell} a CrossSell component
 */
const CrossSell = (props) => {
    const { variant } = props;
    const brandContentFactory = useBrandContentFactory();
    const crossSellOtherVerticals = brandContentFactory.crossSellOtherVerticalsOnResults();
    /**
     * Renders an icon on the related products/cross sell style view.
     * @param {Object} option The properties to render a vertical icon badge
     *  @param {boolean} crossSellVerticals The config to cross sell other verticals
     * @returns {Node} A vertical icon badge
     */
    const renderWrappedIcon = (option, crossSellVerticals) => {
        const className = classNames(styles.badge, `ctm_${option.icon}`);
        if (!crossSellVerticals) {
            return null;
        }

        return (
            <div key={`${option.key}.CrossSell`} className={className}>
                <Anchor href={option.href} target="_blank">
                    <Icon tagName="i" variant={`ctm_${option.icon}`} />
                    <Text size="xxlarge" display="block" innerHTML={option.label} />
                </Anchor>

            </div>
        );
    };

    const pageSettings = pageContext.getProps().models.pageSchemaModel.getSettings();
    const list = verticalLists.ctm;
    const className = styles[`variant_${variant}`] || styles.root;

    if (!list || !crossSellOtherVerticals) {
        return null;
    }
    const badges = list.filter((option) => pageSettings.vertical !== option.key)
        .map((option) => renderWrappedIcon(option, crossSellOtherVerticals));

    /**
     * Iterates through contentProps to remove
     * @returns {CrossSell} A CrossSell component
     */

    return (
        <div className={className}>
            {badges}
        </div>
    );
};

CrossSell.propTypes = {
    variant: PropTypes.string
};

export { CrossSell };
